import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  BusinessProfileAdminDto,
  BusinessAdminQueryDto,
  SetBusinessStatusDto,
} from '../types/admin-api';

export const businessService = {
  getAll: async (query: BusinessAdminQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<BusinessProfileAdminDto>>(
      '/businesses',
      { params: query }
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<BusinessProfileAdminDto>(`/businesses/${id}`);
    return response.data;
  },

  setStatus: async (id: string, data: SetBusinessStatusDto) => {
    const response = await apiClient.put(`/businesses/${id}/status`, data);
    return response.data;
  },
};
